import { useQuery } from '@tanstack/react-query'

import { apiClient } from '@/lib/apiClient'

export interface Health {
  status: string
  environment: 'local' | 'staging' | 'production' | (string & {})
}

/**
 * L'environnement dans lequel tourne l'API — lu une fois par visite.
 *
 * Demandé au serveur plutôt que figé à la compilation : le bandeau dit ce que
 * l'API EST, pas ce que le bundle croyait qu'elle serait. Un front de test
 * branché par erreur sur l'API de production n'afficherait pas de bandeau —
 * et c'est exactement ce qu'il doit faire.
 */
export function useHealth() {
  return useQuery({
    queryKey: ['health'],
    queryFn: () => apiClient.get<Health>('/health'),
    staleTime: Infinity,
    retry: false,
  })
}
